/**
 * When to set the Secure flag on the first-party auth / user-cache cookies.
 *
 * Production always wants Secure (SITE_URL is https, even behind an http
 * proxy). Local `nuxt dev` must not: a Secure cookie is dropped on
 * http://localhost and the next reload looks like a guest (401 /auth/me).
 */
export function shouldSecureAuthCookie(options: {
  dev: boolean
  hostname?: string
  cookieDomain: string
  siteUrl: string
}): boolean {
  if (options.dev) return false
  const host = (options.hostname || '').toLowerCase()
  if (host === 'localhost' || host === '127.0.0.1') return false
  return Boolean(options.cookieDomain || String(options.siteUrl || '').startsWith('https'))
}

export function requestHostname(): string {
  try {
    return useRequestURL().hostname
  }
  catch {
    return ''
  }
}
